export default {
  1: {
    title: 'Nice',
    text: 'Just 1 month of training and my erection is stronger. I’m happy with the results',
  },
  2: {
    title: 'Best of the best',
    text: 'My erection is getting harder with each training day',
  },
  3: {
    title: 'Thank you Kegel',
    text: 'As I reached my 50s I thought my heydays were over. But thanks to kegels I feel like I’m 20 again!',
  },
  4: {
    title: 'Sex booster',
    text: 'Doing Kegels for about 2 months and I can definitely tell that my stamina has really increased. Now I can last for an entire night',
  },
  5: {
    title: 'Daily training paid off',
    text: 'Now I last sooo much longer. This is amazing!',
  },
  6: {
    title: 'Guys, you must try it',
    text: 'I followed this kegel plan and now my performance is at its peak! Guys, this is a real game-changer - don’t sleep on it',
  },
  7: {
    title: 'I’m glad I found these exercises',
    text: 'I’ve been doing Kegel exercises for 2 weeks now and I increased my stamina for real! I feel more confident with my partner. You should try Kegels as well',
  },
  8: {
    title: 'The effect is great',
    text: 'After 4 weeks of kegels, I have no trouble getting and maintaining erection. If you’re struggling as I did, try these exercises',
  },
  9: {
    title: 'Fantastic',
    text: 'The results are amazing'
  },
  10: {
    title: 'Awesome!',
    text: '2 weeks and I can already feel improvements 💪',
  },
  11: {
    title: 'I Feel Like I Have Found A Super Power',
    text: 'Not only does this feel incredible in the loins; it definitely helps me keep a good standing posture! Words cannot even begin to describe the euphoric pleasure I felt throughout my day just by simply tensing my PF muscles!'
  },
  12: {
    title: 'Nice one',
    text: 'Well explained by Dr Kegel and easy to follow. I\'m excited'
  },
  13: {
    title: 'Amazing',
    text: 'I enjoyed so much its very good experience'
  },
  14: {
    title: 'Long overdue',
    text: 'I\'m 59 years old and have attempted to do these exercises I don\'t know how many times over the years, but I always Peter out. 😉 I think this app is pure genius and long overdue. I struggle with PE and have tried just about everything on the market. I\'m sick of taking pills, and I am super excited to try this all-natural approach. My hat is off to the brainstormers of this outstanding idea! wonderful service!!'
  },
  15: {
    title: 'Definitely worth it!',
    text: 'Awesome program!'
  },
  16: {
    title: 'Excellent',
    text: 'Literally changed my life!'
  },
  17: {
    title: 'Few weeks in',
    text: 'I\'m a few weeks in and I can already tell there\'s better blood flow and less temptation to ejaculate early.'
  },
  18: {
    title: 'K training',
    text: 'Why didn\'t I know this 30 years ago?'
  },
  19: {
    title: 'Very effective!',
    text: 'Give it a try and thank me later.'
  },
  20: {
    title: 'Definitely worth it!',
    text: 'Awesome program!'
  },
  21: {
    title: 'To do it is to believe it truly works',
    text: 'I was very skeptical at first. Seems like yeah yeah yeah but nothing works. I started having problems about 1 yr ago. I bought supplements, but never worked. So I came across this ad on my feed. What the heck let me try it. Even though it would cost some money. I\'ve wasted money before. So I decided to try it. I will say I noticed a difference in about 2 weeks. So I was excited about the results in the future. I\'ve now doing the exercises for 72 days straight. WOW I wake up like I\'m in my twenties. Standing at attention, bigger, stronger than in years. I definitely would recommend this plan to everyone. Just remember be committed to doing the exercise as I am. I guarantee you\'ll see results and you\'ll be tremendously happy.'
  },
  23: {
    title: 'Kegel really works',
    text: 'I\'ve had some erection problems before. But after a while with kegel training, it has become so much firmer! It\'s amazing',
  },
  24: {
    title: 'Works perfectly',
    text: 'I decided to give it a try and the results are incredible! You should definitely try Kegel exercises.',
  },
  25: {
    title: 'Solved my problems',
    text: 'My urologist advised me to do Kegels to fix some below belt problems. 6 weeks in and I have no problems at all. If you\'re looking to improve your men\'s health - try it, you won\'t regret it',
  },
  26: {
    title: 'Amazing results',
    text: 'It\'s been only a couple of weeks with Kegel exercises but I can already see a huge difference in my performance. I\'m happy with my results!',
  },
  27: {
    title: 'Super',
    text: 'I\'ve only started recently but the results are incredible! I can tell that my endurance and performance improved a lot',
  },
  28: {
    title: 'Real gains',
    text: 'Kegel exercises are great. The gains are real and every man needs to try it',
  },
  29: {
    title: 'Great training',
    text: 'Kegel Training has changed my life. Now I have absolute control and I decide when I want to finish. This training really worth it',
  },

}
